import * as React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NewImportType } from '../interfaces/dto/new-import-type';
import { createImportType, createImportTypeError$, setAddImportTypeModal } from '../services/import-types.service';

interface Props { }
interface State {
    importType: NewImportType;
    errors: NewImportType;
    submitFailed: boolean;
}

// La colonne LineType est un VARCHAR(3) : ces trois valeurs sont les seules que la base accepte,
// et les deux dernières sont celles que la carte des villes sait colorer
const LineTypes = ['BT', 'HTA', 'THT'];
const FileTypes = ['geojson', 'csv', 'api'];

require('./add-import-type-dialog.component.scss');
export default class AddImportTypeDialog extends React.Component<Props, State> {
    private destroyed$ = new Subject<void>();

    constructor(props: Props) {
        super(props);

        this.state = {
            importType: {
                name: '',
                lineType: 'BT',
                fileType: 'geojson',
                sourceUri: '',
            } as NewImportType,
            errors: {} as NewImportType,
            submitFailed: false,
        } as State;
    }

    public render() {
        const { importType, errors, submitFailed } = this.state;

        return (
            <Dialog open={true} onClose={this.handleClose} aria-labelledby='form-dialog-title'>
                <DialogTitle id='form-dialog-title'>Ajouter un type d'import</DialogTitle>

                <DialogContent>
                    <form className='add-import-type form' onSubmit={e => e.preventDefault()}>
                        <FormControl>
                            <TextField label='Nom' value={importType.name}
                                error={!!errors.name}
                                helperText={errors.name}
                                inputProps={{ maxLength: 128 }}
                                onChange={(e: any) => this.onChangeInput(e, 'name')} />
                        </FormControl>

                        <FormControl>
                            <InputLabel id='import-type-line-type'>Type de lignes actualisées</InputLabel>
                            <Select labelId='import-type-line-type'
                                id='import-type-line-type-select'
                                value={importType.lineType}
                                error={!!errors.lineType}
                                onChange={(e: any) => this.onChangeInput(e, 'lineType')}>
                                {LineTypes.map(lineType =>
                                    <MenuItem key={lineType} value={lineType}>{lineType}</MenuItem>)}
                            </Select>
                        </FormControl>

                        <FormControl>
                            <InputLabel id='import-type-file-type'>Type de fichier</InputLabel>
                            <Select labelId='import-type-file-type'
                                id='import-type-file-type-select'
                                value={importType.fileType}
                                error={!!errors.fileType}
                                onChange={(e: any) => this.onChangeInput(e, 'fileType')}>
                                {FileTypes.map(fileType =>
                                    <MenuItem key={fileType} value={fileType}>{fileType}</MenuItem>)}
                            </Select>
                            <FormHelperText>
                                Descriptif : un nouveau type d'import s'alimente par envoi d'un fichier GeoJson.
                            </FormHelperText>
                        </FormControl>

                        <FormControl>
                            <TextField label='Url source (optionnel)' value={importType.sourceUri}
                                helperText={'Url du jeu de données, pour les imports par lien.'}
                                onChange={(e: any) => this.onChangeInput(e, 'sourceUri')} />
                        </FormControl>

                        {submitFailed
                            && <FormHelperText style={{ color: '#f44336' }}>
                                La création a échoué. Vérifiez la saisie et réessayez.
                            </FormHelperText>}
                    </form>
                </DialogContent>

                <DialogActions>
                    <Button onClick={this.handleClose} color='primary'>
                        Annuler
                    </Button>
                    <Button onClick={this.handleSubmit} color='primary'>
                        Ajouter
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    public componentDidMount() {
        this.subscribeToCreateImportTypeError();
    }

    public componentWillUnmount() {
        this.destroyed$.next();
    }

    private subscribeToCreateImportTypeError() {
        createImportTypeError$().pipe(
            takeUntil(this.destroyed$),
        )
            .subscribe(error => {
                this.setState({ submitFailed: !!error });
            });
    }

    private handleClose = () => {
        setAddImportTypeModal(false);
    }

    private onChangeInput(event: any, key: string) {
        const { importType, errors } = this.state;

        (importType as any)[key] = event.target.value;
        (errors as any)[key] = '';

        this.setState({
            ...this.state,
            importType,
            errors,
        });
    }

    private handleSubmit = (event: any) => {
        event.preventDefault();

        const { importType } = this.state;
        const errors = {} as any;

        if (!importType.name.trim()) errors.name = 'Le nom est obligatoire';
        if (!importType.lineType) errors.lineType = 'Le type de lignes est obligatoire';
        if (!importType.fileType) errors.fileType = 'Le type de fichier est obligatoire';

        if (Object.keys(errors).length) {
            this.setState({ errors });
            return;
        }

        createImportType({
            ...importType,
            name: importType.name.trim(),
            sourceUri: (importType.sourceUri || '').trim(),
        });
    }
}
